export default `

.css-ahj2mt-MuiTypography-root {
  padding: 0px;
}

.css-o4b71y-MuiAccordionSummary-content.Mui-expanded {
  margin: 0px;
}

.css-1kz0hui-MuiSlider-valueLabel {
  background-color: #0b3275;
  }
  
.css-1aznpnh-MuiSlider-root {
  height: 6px; 
  color: #050922;
}
.css-14pt78w-MuiSlider-rail {
  color: #CFD2D6;
}

.css-1tfve6q-MuiSlider-mark {
  position: initial;
}

.css-6cwnna-MuiSlider-mark {
  position: initial;
}
.css-1eoe787-MuiSlider-markLabel, 
.css-yafthl-MuiSlider-markLabel {
    font-family: inherit !important;
    color: rgba(0, 0, 0, 0.87) !important;
}

.css-nnid7-MuiSlider-valueLabel.MuiSlider-valueLabelOpen {
  background-color: #0b3275;
}

.css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked{
  color: #050922 !important;
}
.css-zun73v.Mui-checked {
  color: #050922 !important;
}

.css-o4b71y-MuiAccordionSummary-content{
  margin: 0;
}
  
.css-o4b71y-MuiAccordionSummary-content.Mui-expanded {
  margin: 0 !important;
}

.css-15v22id-MuiAccordionDetails-root {
  padding: 0px !important;
}

.css-sh22l5-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded{
  min-height: 0;
}

.carousel-indicators{
  margin-bottom: -0rem !important;
 }

.carousel-indicators [data-bs-target] {
  width: 5px;
  height: 5px;
  border-radius: 100%;
  background-color: var(--secondary-color);
  border: 0;
}

.carousel-indicators .active {
  width: 8px;
  height: 8px;
  background-color: var(--primary-color);
}
`